var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileLinkArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.75 0C26 0 33.5 7.5 33.5 16.75S26 33.5 16.75 33.5 0 26 0 16.75 7.5 0 16.75 0m0 1.5C8.328 1.5 1.5 8.328 1.5 16.75S8.328 32 16.75 32 32 25.172 32 16.75 25.172 1.5 16.75 1.5m2.116 8.606 5.778 5.778c.358.358.386.92.079 1.314l-.084.095a1 1 0 0 1-.548.28l-5.26 4.952c-.4.376-1.037.363-1.425-.026l.17.171-.17-.17.091.08a.96.96 0 0 1 .01-1.203l.084-.092 3.966-3.785H9.993a.994.994 0 0 1-.993-1c0-.552.447-1 .993-1l11.438-.001-3.98-3.98a.994.994 0 0 1 .006-1.408 1 1 0 0 1 1.409-.005"
})));
export default SvgInstagramMobileLinkArrow;